// extracted by mini-css-extract-plugin
module.exports = {"l-global-footer":"_l-footer_l-global-footer__XHemk","l-footer-reg":"_l-footer_l-footer-reg__ekW1F"};